import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

import {
  getChooseYourService,
  postChooseYourService,
} from 'redux/actions/UserChooseYourService';
import { getServiceRegion, postAddSubVendorRegion } from 'redux/actions/UserServiceCity';
import { getProfile } from 'redux/actions/UserProfile';
import CommonForm from 'components/commonForm/CommonForm';
import Loader from 'components/loader/Loader';
import login_hand from 'assets/images/login_hand.png';
import logo from 'assets/images/companyLogo.svg';
import { commonObject } from 'utils/enumObject';
import { companyDetails } from 'utils/companyDetails';
import { getBranding } from 'config/tenantConfig';
import CommonButton from 'components/commonButton/CommonButton';

export default function ChooseYourService() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id = localStorage.getItem('companyId');
  const location = localStorage.getItem('location');
  const chooseYourServiceData = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );
  const loaderService = useSelector(
    (state) => state?.userChooseYourService?.loading
  );
  const userProfileData = useSelector((state) => state?.userProfile?.userProfile?.data);
  const regionSelection = useSelector((state) => state?.userServiceRegion?.userServiceRegion?.data);

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [validationError, setValidationError] = useState("");
  const [locationError, setLocationError] = useState("");

  useEffect(() => {
    const serviceRegion = localStorage.getItem('serviceRegion');
    const status = localStorage.getItem('status');
    if (serviceRegion === 'true') {
      if (status === 'Pending') {
        navigate('/compliance/5?upload=true');
      } else {
        navigate('/dashboard');
      }
    }
    const data = {
      id: id,
      type: 'Company',
      businessType: commonObject.businessType
    };
    const service = {
      serviceCityId: location
    };
    dispatch(getChooseYourService(data));
    dispatch(getServiceRegion(service));
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    if (userProfileData?.serviceRegion === true) {
      localStorage.setItem('serviceRegion', userProfileData?.serviceRegion);
      localStorage.setItem('status', userProfileData?.status);
      if (userProfileData?.status === 'Pending') {
        navigate('/compliance/5?upload=true');
      } else {
        navigate('/rideTrack/2');
      }
    }
  }, [userProfileData]);

  const handleCheckboxChange = (serviceId) => {
    if (selectedCheckboxes.includes(serviceId)) {
      setSelectedCheckboxes(selectedCheckboxes.filter(id => id !== serviceId));
    } else {
      setSelectedCheckboxes([...selectedCheckboxes, serviceId]);
    }
  };

  const handleService = (serviceId) => {
    setSelectedCheckboxes([])
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const calculateServiceValue = () => {
    if (selectedServices.includes("public") && selectedServices.includes("corporate")) {
      return 2; // Both selected
    } else if (selectedServices.includes("public")) {
      return 1; // Only public selected
    } else if (selectedServices.includes("corporate")) {
      return 0; // Only corporate selected
    } else {
      return null; // None selected
    }
  };
useEffect(() =>{
  const data = {
    id: id,
    type: 'Company',
    businessType: calculateServiceValue()
  };
  dispatch(getChooseYourService(data));
},[selectedServices])

  const handleRedirect = () => {
    const serviceValue = calculateServiceValue();
    if (selectedCheckboxes.length === 0 || serviceValue === null) {
      setValidationError("Please select at least one service and one duty type.");
    } else {
      setValidationError("");
      setLocationError('');

      const dataservice = {
        id: id,
        type: 'Company',
        serviceId: selectedCheckboxes,
        businessType: serviceValue,
      };
      dispatch(postChooseYourService(dataservice));
    }
  };

  const onBackBtn = () => {
    localStorage.clear();
    navigate('/login');
    window.location.reload()
  };

  const chooseServices = [
    {
      id: "public",
      title: "Public",
      value: 1
    },
    {
      id: "corporate",
      title: "Corporate",
      value: 0
    }
  ];

  return (
    <>
      <Box sm={{ flexGrow: 1 }} className="">
        <Grid container>
          <Grid item sm={6}>
            <Box
              alignItems={'center'}
              sx={{ display: { xs: 'none', sm: 'flex' } }}
              className="positionAbsolute otpLogo ml40"
            >
              {/* --- Removing as it is not required ---*/}
              {/* <ArrowBackIcon
                onClick={onBackBtn}
                className='cursor'
              /> */}
              <img src={getBranding().logo || companyDetails?.companyLogo} className="maxWidth" alt="otplogo" />
            </Box>
            <div className="loginInput mobileBg">
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                rowSpacing={4}
              >
                <Grid item sm={7} xs={12} className="textCenter">
                  <img src={login_hand} alt="hand" />
                  <Typography className="fontMedium font36 colorYellow">
                    <span className="colorBlue">Choose Your </span>Services
                  </Typography>
                </Grid>
                  <Grid item sm={6} xs={12}>
                    <Typography pl={1} className='font18' pb={1}>Services<span className='colorRed'>*</span></Typography>
                    <Grid container className='serviceWrapper'>
                      {chooseServices?.map((value) => (
                        <Grid key={value.id} item xs={4} className={`serviceCheckbox ${selectedServices.includes(value.id) && "activeServiceCheckbox"}`}
                          onClick={() => handleService(value.id)}>
                          {selectedServices.includes(value.id) ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}
                          <Typography pl={1} className='font14 pl10'>{value?.title}</Typography>
                        </Grid>
                      ))}
                    </Grid>
                   {selectedServices?.length > 0 && 
                   <Grid className='mt20'>
                     {loaderService ? <Loader height="10vh"/> :
                     <> 
                     <Typography className='font18' pb={1}>Duty Type<span className='colorRed'>*</span></Typography>
                      <FormGroup>
                        {chooseYourServiceData?.map((service, idx) => (
                          <FormControlLabel
                            key={service.id}
                            control={
                              <Checkbox
                                checked={selectedCheckboxes.includes(service.id)}
                                onChange={() => handleCheckboxChange(service.id)}
                              />
                            }
                            className="chooseCheckbox tripType"
                            label={service?.name}
                          />
                        ))}
                      </FormGroup>
                      </>}
                      </Grid>}
                    <Box className="margintop50">
                      <CommonButton name="Confirm" btnClass="btnYellow btnSubmit" onClick={handleRedirect} disabled={selectedServices.length === 0 || selectedCheckboxes.length === 0} />
                    </Box>
                  </Grid>
                <Grid item sm={7} xs={12} className="textCenter"></Grid>
              </Grid>
            </div>
          </Grid>
          <Grid
            item
            sm={6}
            sx={{ display: { xs: "none", sm: "flex" } }}
            className="bgImage"
          >
            <div className="loginBgImg"></div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
